declare global {
  interface Window {
    // Contentsquare https://docs.contentsquare.com/uxa-en/
    _uxa?: [string, unknown][]
  }
}

export const activateContentsquareExperiment = (
  experimentName: string,
): void => {
  /* eslint-disable no-underscore-dangle -- Contentsquare works with a global `_uxa` similar to GTM dataLayer */
  window._uxa ??= []
  window._uxa.push(['trackPageEvent', `${experimentName}_activated`])
  /* eslint-enable no-underscore-dangle */
}
